'use strict';

import angular from 'angular';

import incidentsCtrl from './incidents';

const MODULE_NAME = 'daupler.incidents.controllers';

var app = angular.module(MODULE_NAME, [
]);
app.controller('IncidentsCtrl', incidentsCtrl);

export default MODULE_NAME;
